// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes WizardSlideIn {
  0% {
    margin-left: 100%;
  }
  100% {
    margin-left: 0;
  }
}
@keyframes WizardSlideOut {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -100%;
  }
}
wizard .wizard-content {
  display: block;
  width: 100%;
  position: relative;
  overflow: hidden;
}
wizard .wizard-content wizard-step {
  display: block;
  width: 100%;
  margin-left: 0;
  top: 0;
}
wizard.au-animate .wizard-content wizard-step.au-leave-active {
  animation: WizardSlideOut 0.5s;
  position: absolute;
}
wizard.au-animate .wizard-content wizard-step.au-enter-active {
  animation: WizardSlideIn 0.5s;
}
wizard.au-animate .wizard-content.back wizard-step.au-leave-active {
  animation: WizardSlideIn 0.5s reverse;
  position: absolute;
}
wizard.au-animate .wizard-content.back wizard-step.au-enter-active {
  animation: WizardSlideOut 0.5s reverse;
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/wizard/wizard.scss"],"names":[],"mappings":"AAEA;EACE;IACE,iBAAA;EADF;EAIA;IACE,cAAA;EAFF;AACF;AAKA;EACE;IACE,cAAA;EAHF;EAMA;IACE,kBAAA;EAJF;AACF;AAUE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAWI;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;AATN;AAiBQ;EACE,8BAAA;EACA,kBAAA;AAfV;AAkBQ;EACE,6BAAA;AAhBV;AAuBU;EACE,qCAAA;EACA,kBAAA;AArBZ;AAwBU;EACE,sCAAA;AAtBZ","sourcesContent":["\n\n@keyframes WizardSlideIn {\n  0% {\n    margin-left: 100%;\n  }\n\n  100% {\n    margin-left: 0;\n  }\n}\n\n@keyframes WizardSlideOut {\n  0% {\n    margin-left: 0;\n  }\n\n  100% {\n    margin-left: -100%;\n  }\n}\n\n$wizardSlideDuration : 0.5s;\nwizard {\n\n  .wizard-content {\n    display: block;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n\n\n    wizard-step {\n      display: block;\n      width: 100%;\n      margin-left: 0;\n      top: 0;\n\n    }\n  }\n\n  &.au-animate {\n    .wizard-content {\n      wizard-step {\n        &.au-leave-active {\n          animation: WizardSlideOut $wizardSlideDuration;\n          position: absolute;\n        }\n\n        &.au-enter-active {\n          animation: WizardSlideIn $wizardSlideDuration;\n        }\n      }\n\n      &.back {\n        wizard-step {\n\n          &.au-leave-active {\n            animation: WizardSlideIn $wizardSlideDuration reverse;\n            position: absolute;\n          }\n\n          &.au-enter-active {\n            animation: WizardSlideOut $wizardSlideDuration reverse;\n          }\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
